import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_46yqo0x0y0: FaireBrandEntity = {
  token: "b_46yqo0x0y0",
  type: "brand",
  name: "El Paso Saddleblanket",
  avatarUrl:
    "https://cdn.faire.com/fastly/dbd3abaf3377691855402c10ceaeaf4e413be5a2f930596fd3f3833597037568.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/616baf6067b58f6d41c83300f33cd800782ed353152d48d11e9f455d5cac83fd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dbd3abaf3377691855402c10ceaeaf4e413be5a2f930596fd3f3833597037568.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/616baf6067b58f6d41c83300f33cd800782ed353152d48d11e9f455d5cac83fd.jpeg",
  location: "El Paso, TX, USA",
  minimumOrderDollars: 406,
  rating: 4.7,
  reviewCount: 102,
  isTopShop: true,
  isInsider: true,
  description:
    'The El Paso Saddleblanket Company is the World’s Largest Southwest Trading Post with a \'WHOLESALE ONLY\' showroom touting one of the widest selections of Southwest and Western crafts in the world- overflowing with Southwest rugs, blankets, purses, shawls, bedspreads, hand-painted artifacts, hand-chipped arrowheads, cow skulls, handwoven baskets, serapes, and more—all at El Paso Saddleblanket’s World Famous "Wholesale Direct" honest low prices.  95% of our textile products are designed "in-house" by our own design team and are not available anywhere else.',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:07.302Z",
    importedBy: "entity-db-cli",
  },
};
